<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <div class="asso-info-edit"><Button type="info" :to="{path: '/manage/association/other/edit', query:{id: assoInfo.assoId}}">修改该机构信息</Button></div>
            <Row class="asso-info-item">
              <Col span="2" class="asso-info-prefix">机构编号：</Col>
              <Col span="22">{{assoInfo.assoId}}</Col>
            </Row>
            <Row class="asso-info-item">
              <Col span="2" class="asso-info-prefix">机构名称：</Col>
              <Col span="22">{{assoInfo.assoName}}</Col>
            </Row>
            <Row class="asso-info-item">
              <Col span="2" class="asso-info-prefix">电子邮件：</Col>
              <Col span="22">{{assoInfo.assoEmail}}</Col>
            </Row>
            <Row class="asso-info-item">
              <Col span="2" class="asso-info-prefix">联系电话：</Col>
              <Col span="22">{{assoInfo.assoTel}}</Col>
            </Row>
            <Row class="asso-info-item">
              <Col span="2" class="asso-info-prefix">机构类型：</Col>
              <Col span="22">{{assoInfo.assoType}}</Col>
            </Row>
            <Row class="asso-info-item" v-if="assoInfo.website!=null && assoInfo.website!=''">
              <Col span="2" class="asso-info-prefix">机构站点：</Col>
              <Col span="22">{{assoInfo.website}}</Col>
            </Row>
            <Row class="asso-info-item">
              <Col span="2" class="asso-info-prefix">机构介绍：</Col>
              <Col span="22">{{assoInfo.assoDesc}}</Col>
            </Row>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader
  },

  data () {
    return {
      token: '',
      assoInfo: {},
    }
  },

  //页面加载完成后执行
  //页面加载完成
  mounted: function() {
    //初始化用户信息
    this.initAuthData()

    //获取机构信息
    this.getAssociationInfo()
  },

  //页面方法
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
      }
    },

    //从服务端获取文字列表
    getAssociationInfo() {
      let vm = this
      let id = parseInt(vm.$route.query.id)
      if(isNaN(id) || id <= 0) {
        return;
      }
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/associations/association-get-for-other-show",
        {id: id, status: 1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        vm.assoInfo = info.data
      }).catch(function(error) {
        console.log(error)
      });
    },

  }
}
</script>